(() => {
  const MAKE_WEBHOOK =
    'https://hook.us2.make.com/kg9nrrhj40rnp6gm5bduyhk4u8o5v0qa';

  const TOPUP_PRODUCT_PATH = '/products/nhip-esim-top-up';
  const decodedPath = decodeURIComponent(window.location.pathname).toLowerCase();

  if (!decodedPath.includes(TOPUP_PRODUCT_PATH)) return;

  let variantData = [];

  let compatibilityState = {
    esimId: '',
    packages: new Map(),
    selectedSku: '',
    selectedPackageCode: '',
  };

  let verificationState = {
    key: '',
    behaviour: '',
    packageCode: '',
    verifiedAt: '',
    replaceAcknowledged: false,
  };

  function getProductForm() {
    return (
      document.querySelector('product-form form') ||
      document.querySelector('form[action*="/cart/add"]')
    );
  }

  function getSelectedVariant() {
    if (compatibilityState.selectedSku) {
      const selectedCompatible = variantData.find(
        (variant) => String(variant.sku || '') === compatibilityState.selectedSku
      );

      if (selectedCompatible) return selectedCompatible;
    }

    const scope = document.querySelector('product-info') || document;

    const selects = [
      ...scope.querySelectorAll(
        'variant-selects select, select[name^="options["]'
      ),
    ];

    if (selects.length) {
      const selectedOptions = selects.map((select) =>
        String(select.value).trim()
      );

      const matchedVariant = variantData.find((variant) => {
        if (!Array.isArray(variant.options)) return false;

        return selectedOptions.every(
          (value, index) =>
            String(variant.options[index] ?? '').trim() === value
        );
      });

      if (matchedVariant) return matchedVariant;
    }

    // Fallback to Dawn's hidden variant ID only if needed.
    const form = getProductForm();
    const idInput = form?.querySelector('input[name="id"]');

    if (!idInput) return null;

    return (
      variantData.find(
        (variant) => String(variant.id) === String(idInput.value)
      ) || null
    );
  }

  function getOptionSelects() {
    const scope = document.querySelector('product-info') || document;

    return [
      ...scope.querySelectorAll(
        'variant-selects select, select[name^="options["]'
      ),
    ];
  }

  function getVariantPicker() {
    const scope = document.querySelector('product-info') || document;

    return scope.querySelector('variant-selects, variant-radios');
  }

  function hideOriginalVariantPicker() {
    const picker = getVariantPicker();

    if (!picker) return;

    picker.style.display = 'none';
    picker.setAttribute('aria-hidden', 'true');
  }

  function getPackageIdFromSku(sku) {
    const value = String(sku || '').trim();

    if (!value.startsWith('ESIM-TOPUP-')) return '';

    return value.replace('ESIM-TOPUP-', '');
  }

  function formatVariantPrice(variant) {
    const amount = Number(variant?.price ?? 0) / 100;

    const currency =
      window.Shopify?.currency?.active ||
      document.documentElement.getAttribute('data-currency') ||
      'USD';

    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency,
      }).format(amount);
    } catch (_) {
      return `$${amount.toFixed(2)}`;
    }
  }

  function clearCompatibleTopUps() {
    compatibilityState = {
      esimId: '',
      packages: new Map(),
      selectedSku: '',
    selectedPackageCode: '',
    };

    const wrap = document.querySelector('#nhip-topup-compatible-wrap');
    const list = document.querySelector('#nhip-topup-compatible-list');
    const status = document.querySelector('#nhip-topup-compatible-status');

    if (wrap) wrap.style.display = 'none';
    if (list) list.innerHTML = '';
    if (status) status.innerHTML = '';
  }

  function parseCompatibleTopUps(rawText) {
    const map = new Map();

    String(rawText || '')
      .split(';')
      .map((part) => part.trim())
      .filter(Boolean)
      .forEach((part) => {
        const [packageIdRaw, behaviourRaw, referenceRaw] = part.split('|');

        const packageId = String(packageIdRaw || '').trim();
        const behaviour = String(behaviourRaw || '').trim().toLowerCase();
        const reference = String(referenceRaw || '').trim();
        const shopifySku = reference.startsWith('ESIM-TOPUP-') ? reference : '';
        const supplierName = shopifySku ? '' : reference;

        if (
          (/^\d+$/.test(packageId) || /^STELLAR-[A-Z0-9_:-]+$/i.test(packageId) || /^MOBISIM-[A-Z0-9_:-]+$/i.test(packageId)) &&
          (behaviour === 'accumulates' || behaviour === 'replaces')
        ) {
          map.set(packageId, { behaviour, shopifySku, supplierName });
        }
      });

    return map;
  }

  function setCompatibleStatus(html) {
    const status = document.querySelector('#nhip-topup-compatible-status');

    if (!status) return;

    status.innerHTML = html;
  }

  function normalizeSupplierPlanTitle(name) {
    const value = String(name || '').trim();
    const match = value.match(/^(.*?)\s+(\d+(?:\.\d+)?(?:GB|MB))\s+(\d+)\s*Days?$/i);

    if (!match) return value;

    return `${match[1].trim()} / ${match[2].toUpperCase()} / ${match[3]} Days`;
  }

  function renderCompatibleTopUps(esimId, packageMap) {
    const wrap = document.querySelector('#nhip-topup-compatible-wrap');
    const list = document.querySelector('#nhip-topup-compatible-list');

    if (!wrap || !list) return;

    const compatibleByVariantId = new Map();
    const matches = [];

    packageMap.forEach((meta, packageId) => {
      const shopifySku = String(meta?.shopifySku || '').trim();
      const supplierTitle = normalizeSupplierPlanTitle(meta?.supplierName || '');

      const variant = variantData.find((candidate) => {
        const candidateTitle = Array.isArray(candidate.options)
          ? candidate.options.join(' / ')
          : String(candidate.title || '');

        return (
          candidate.available !== false &&
          ((shopifySku && String(candidate.sku || '') === shopifySku) ||
            (supplierTitle && candidateTitle === supplierTitle))
        );
      });

      if (variant && !compatibleByVariantId.has(String(variant.id))) {
        compatibleByVariantId.set(String(variant.id), {
          packageId,
          behaviour: meta?.behaviour || 'unknown',
        });
        matches.push(variant);
      }
    });

    list.innerHTML = '';

    if (!matches.length) {
      wrap.style.display = 'block';

      setCompatibleStatus(
        `<strong>No NHIP Top-Ups currently offered on this page are compatible with eSIM ${esimId}.</strong>`
      );

      return;
    }

    setCompatibleStatus(
  `<strong>Compatible Top-Ups for NHIP eSIM ${esimId}</strong><br>
   <small>
     ✓ Adds Data = keeps your remaining data<br>
     ⚠ Replaces Data = existing remaining data will be lost
   </small>`
);

    matches.forEach((variant) => {
      const compatible =
        compatibleByVariantId.get(String(variant.id));

      const packageId = compatible?.packageId || '';
      const behaviour = compatible?.behaviour || 'unknown';

      const optionText = Array.isArray(variant.options)
        ? variant.options.join(' / ')
        : variant.title || variant.sku;

      const behaviourText =
        behaviour === 'accumulates'
          ? '✓ Adds Data — remaining data preserved'
          : '⚠ Replaces Data — remaining data will be lost';

      const button = document.createElement('button');

      button.type = 'button';
      button.className =
        'button button--secondary nhip-compatible-topup';

      button.dataset.variantId = String(variant.id);
      button.dataset.sku = String(variant.sku || '');

      button.style.width = '100%';
button.style.display = 'grid';
button.style.gridTemplateColumns = 'minmax(0, 1fr) auto';
button.style.columnGap = '12px';
button.style.alignItems = 'start';
button.style.textAlign = 'left';
button.style.margin = '8px 0';
button.style.padding = '12px 14px';
button.style.border = '1px solid rgba(15,44,76,.25)';
button.style.borderRadius = '8px';
button.style.background = '#fff';
button.style.cursor = 'pointer';

button.innerHTML = `
  <div style="min-width:0;overflow-wrap:anywhere;">
    <div style="font-weight:700;line-height:1.35;">
      ${optionText}
    </div>
    <div style="margin-top:3px;font-weight:600;line-height:1.3;">
      ${
        behaviour === 'accumulates'
          ? '✓ Adds Data'
          : '⚠ Replaces Data'
      }
    </div>
  </div>

  <div style="font-weight:700;white-space:nowrap;text-align:right;line-height:1.35;">
    ${formatVariantPrice(variant)}
  </div>
`;

      button.addEventListener('click', async () => {
        await selectCompatibleVariant(variant);

        compatibilityState.selectedSku = String(variant.sku || '');
        compatibilityState.selectedPackageCode = packageId;

       document
  .querySelectorAll('.nhip-compatible-topup')
  .forEach((item) => {
    const isSelected = item === button;

    item.setAttribute(
      'aria-pressed',
      isSelected ? 'true' : 'false'
    );

    item.style.background = isSelected
      ? '#0F2C4C'
      : '#fff';

    item.style.color = isSelected
      ? '#fff'
      : '#000';

    item.style.border = isSelected
      ? '2px solid #0F2C4C'
      : '1px solid rgba(15,44,76,.25)';
  });

        setTimeout(() => {
          setMessage(
            `
              <strong>Selected:</strong> ${optionText}<br>
              ${behaviourText}<br><br>
              <strong>
                Click Verify Top-Up to re-check this exact package before purchase.
              </strong>
            `
          );
        }, 350);
      });

      list.appendChild(button);
    });

    wrap.style.display = 'block';
  }

  async function selectCompatibleVariant(variant) {
    invalidateVerification();

    const selects = getOptionSelects();

    if (selects.length && Array.isArray(variant.options)) {
      for (let index = 0; index < selects.length; index += 1) {
        const select = selects[index];
        const desiredValue = String(
          variant.options[index] ?? ''
        ).trim();

        if (!desiredValue) continue;

        const optionExists = [...select.options].some(
          (option) =>
            String(option.value).trim() === desiredValue
        );

        if (optionExists) {
          select.value = desiredValue;

          select.dispatchEvent(
            new Event('change', {
              bubbles: true,
            })
          );

          await new Promise((resolve) =>
            setTimeout(resolve, 180)
          );
        }
      }
    }

    const form = getProductForm();
    const idInput = form?.querySelector('input[name="id"]');

    if (idInput) {
      idInput.value = String(variant.id);

      idInput.dispatchEvent(
        new Event('change', {
          bubbles: true,
        })
      );
    }

    hideOriginalVariantPicker();
  }

  async function findCompatibleTopUps() {
    const button = document.querySelector(
      '#nhip-topup-find-compatible'
    );

    const esimInput = document.querySelector(
      '#nhip-existing-esim-id'
    );

    const esimId = esimInput?.value.trim();

    invalidateVerification();
    clearCompatibleTopUps();
    disablePurchase();

    if (!esimId || !/^\d+$/.test(esimId)) {
      setMessage(
        '<strong>Enter a valid NHIP eSIM ID to find compatible Top-Ups.</strong>',
        'blocked'
      );

      return;
    }

    if (button) {
      button.disabled = true;
      button.textContent = 'Finding Compatible Top-Ups…';
    }

    setMessage(
      '<strong>Checking which NHIP Top-Ups are compatible with this eSIM…</strong>'
    );

    const controller = new AbortController();
    const timeout = setTimeout(
      () => controller.abort(),
      12000
    );

    try {
      const url =
        `${MAKE_WEBHOOK}` +
        `?esim_id=${encodeURIComponent(esimId)}` +
        `&mode=list_compatible`;

      const res = await fetch(url, {
        method: 'GET',
        cache: 'no-store',
        signal: controller.signal,
      });

      if (!res.ok) {
        throw new Error(`HTTP ${res.status}`);
      }

      const raw = await res.text();

      /*
       * If Make returns JSON, it means the request
       * was blocked or returned a structured error.
       */
      if (raw.trim().startsWith('{')) {
        let result = null;

        try {
          result = JSON.parse(raw);
        } catch (_) {
          result = null;
        }

        if (result?.reason === 'esim_not_eligible') {
          setMessage(
            `
              <strong>This eSIM is not eligible for Top-Up.</strong><br>
              The plan may be expired or otherwise unavailable for Top-Up.
            `,
            'blocked'
          );

          return;
        }

        throw new Error(
          'Unexpected compatibility response'
        );
      }

      const packageMap = parseCompatibleTopUps(raw);

      if (!packageMap.size) {
        setMessage(
          `
            <strong>
              No compatible Top-Up packages were returned for this eSIM.
            </strong><br>
            Please confirm the NHIP eSIM ID or contact NHIP support.
          `,
          'blocked'
        );

        return;
      }

      compatibilityState = {
        esimId,
        packages: packageMap,
        selectedSku: '',
    selectedPackageCode: '',
      };

      await loadVariants();

      renderCompatibleTopUps(
        esimId,
        packageMap
      );

      setMessage(
        `
          <strong>Compatible Top-Ups found.</strong><br>
          Select one from the list above, then click Verify Top-Up.
        `
      );
    } catch (err) {
      console.error(
        'NHIP Top-Up compatibility lookup failed',
        err
      );

      clearCompatibleTopUps();

      setMessage(
        `
          <strong>We could not load compatible Top-Ups.</strong><br>
          Please try again or contact NHIP support.
        `,
        'blocked'
      );
    } finally {
      clearTimeout(timeout);

      if (button) {
        button.disabled = false;
        button.textContent =
          'Find Compatible Top-Ups';
      }
    }
  }

  function getAddToCartButton() {
    const form = getProductForm();

    if (!form) return null;

    return (
      form.querySelector(
        'button[type="submit"][name="add"]'
      ) ||
      form.querySelector(
        'button[type="submit"]'
      )
    );
  }

  function hideAcceleratedCheckout() {
    document.body.classList.add(
      'nhip-topup-page'
    );

    if (
      !document.querySelector(
        '#nhip-topup-safety-style'
      )
    ) {
      const style =
        document.createElement('style');

      style.id =
        'nhip-topup-safety-style';

      style.textContent = `
        body.nhip-topup-page .shopify-payment-button {
          display: none !important;
        }
      `;

      document.head.appendChild(style);
    }
  }

  function disablePurchase() {
    const button = getAddToCartButton();

    if (!button) return;

    button.disabled = true;

    button.setAttribute(
      'aria-disabled',
      'true'
    );

    button.dataset.nhipTopupLocked =
      'true';
  }

  function enablePurchase() {
    const button = getAddToCartButton();
    const variant = getSelectedVariant();

    if (
      !button ||
      !variant ||
      variant.available === false
    ) {
      return;
    }

    button.disabled = false;

    button.removeAttribute(
      'aria-disabled'
    );

    delete button.dataset.nhipTopupLocked;
  }

  function setMessage(
    html,
    type = 'neutral'
  ) {
    const box =
      document.querySelector(
        '#nhip-topup-result'
      );

    if (!box) return;

    box.innerHTML = html;
    box.dataset.state = type;

    box.style.display = 'block';
    box.style.padding = '14px';
    box.style.marginTop = '12px';

    box.style.border =
      '1px solid rgba(0,0,0,.2)';

    box.style.borderRadius = '8px';
  }

  function ensurePropertyInput(name) {
    const form = getProductForm();

    if (!form) return null;

    let input = form.querySelector(
      `input[name="properties[${name}]"]`
    );

    if (!input) {
      input =
        document.createElement('input');

      input.type = 'hidden';

      input.name =
        `properties[${name}]`;

      form.appendChild(input);
    }

    return input;
  }

  function setProperty(name, value) {
    const input =
      ensurePropertyInput(name);

    if (input) {
      input.value = value ?? '';
    }
  }

  function writeVerificationProperties(
    esimId,
    variant
  ) {
    setProperty(
      '_NHIP Top-Up Verified',
      'true'
    );

    setProperty(
      '_NHIP eSIM ID',
      esimId
    );

    setProperty(
      '_NHIP Top-Up SKU',
      variant.sku
    );

    setProperty(
      '_NHIP Package Code',
      verificationState.packageCode
    );

    setProperty(
      '_NHIP Top-Up Behaviour',
      verificationState.behaviour
    );

    setProperty(
      '_NHIP Top-Up Verified At',
      verificationState.verifiedAt
    );

    setProperty(
      '_NHIP Replace Acknowledged',
      verificationState.replaceAcknowledged
        ? 'true'
        : 'false'
    );
  }

  function clearVerificationProperties() {
    setProperty(
      '_NHIP Top-Up Verified',
      ''
    );

    setProperty(
      '_NHIP eSIM ID',
      ''
    );

    setProperty(
      '_NHIP Top-Up SKU',
      ''
    );

    setProperty(
      '_NHIP Package Code',
      ''
    );

    setProperty(
      '_NHIP Top-Up Behaviour',
      ''
    );

    setProperty(
      '_NHIP Top-Up Verified At',
      ''
    );

    setProperty(
      '_NHIP Replace Acknowledged',
      ''
    );
  }

  function resetVerificationState() {
    verificationState = {
      key: '',
      behaviour: '',
      packageCode: '',
      verifiedAt: '',
      replaceAcknowledged: false,
    };
  }

  function invalidateVerification() {
    resetVerificationState();

    clearVerificationProperties();

    disablePurchase();

    const acknowledgement =
      document.querySelector(
        '#nhip-topup-replace-ack-wrap'
      );

    if (acknowledgement) {
      acknowledgement.style.display =
        'none';
    }

    const checkbox =
      document.querySelector(
        '#nhip-topup-replace-ack'
      );

    if (checkbox) {
      checkbox.checked = false;
    }
  }

  function currentVerificationKey() {
    const esimId =
      document
        .querySelector(
          '#nhip-existing-esim-id'
        )
        ?.value.trim();

    const variant =
      getSelectedVariant();

    if (!esimId || !variant?.sku) {
      return '';
    }

    return `${esimId}|${variant.sku}`;
  }

  function purchaseIsAuthorized() {
    const currentKey =
      currentVerificationKey();

    if (
      !currentKey ||
      currentKey !==
        verificationState.key
    ) {
      return false;
    }

    if (
      verificationState.behaviour ===
      'accumulates'
    ) {
      return true;
    }

    if (
      verificationState.behaviour ===
        'replaces' &&
      verificationState
        .replaceAcknowledged === true
    ) {
      return true;
    }

    return false;
  }

  async function loadVariants() {
    try {
      const productPath =
        window.location.pathname.replace(
          /\/$/,
          ''
        );

      const res = await fetch(
        `${productPath}.js`,
        {
          cache: 'no-store',
        }
      );

      if (!res.ok) {
        throw new Error(
          `HTTP ${res.status}`
        );
      }

      const product =
        await res.json();

      variantData =
        product.variants || [];
    } catch (err) {
      console.error(
        'NHIP Top-Up: unable to load product variants',
        err
      );

      variantData = [];
    }
  }

  async function verifyTopUp() {
    const verifyButton =
      document.querySelector(
        '#nhip-topup-verify'
      );

    const esimInput =
      document.querySelector(
        '#nhip-existing-esim-id'
      );

    const esimId =
      esimInput?.value.trim();

    if (
      !esimId ||
      !/^\d+$/.test(esimId)
    ) {
      invalidateVerification();

      setMessage(
        '<strong>Enter a valid NHIP eSIM ID to verify this Top-Up.</strong>',
        'blocked'
      );

      return;
    }

    const variant =
      getSelectedVariant();

    if (
      !variant ||
      !variant.sku
    ) {
      invalidateVerification();

      setMessage(
        '<strong>Unable to identify the selected Top-Up package.</strong>',
        'blocked'
      );

      return;
    }

    if (
      !variant.sku.startsWith(
        'ESIM-TOPUP-'
      )
    ) {
      invalidateVerification();

      setMessage(
        '<strong>This is not a valid NHIP Top-Up package.</strong>',
        'blocked'
      );

      return;
    }

    const packageCode =
      compatibilityState.selectedPackageCode ||
      variant.sku.replace(
        'ESIM-TOPUP-',
        ''
      );

    /*
     * Customer must have:
     * 1. entered an eSIM,
     * 2. loaded compatible plans,
     * 3. selected one from our compatible list.
     */
    if (
      compatibilityState.esimId !==
        esimId ||
      !compatibilityState.packages.has(
        packageCode
      ) ||
      compatibilityState.selectedSku !==
        variant.sku
    ) {
      invalidateVerification();

      setMessage(
        '<strong>Find compatible Top-Ups and select one before verifying.</strong>',
        'blocked'
      );

      return;
    }

    const verificationKey =
      `${esimId}|${variant.sku}`;

    invalidateVerification();

    setMessage(
      '<strong>Checking your eSIM and Top-Up package…</strong>'
    );

    if (verifyButton) {
      verifyButton.disabled = true;
      verifyButton.textContent =
        'Checking…';
    }

    const controller =
      new AbortController();

    const timeout =
      setTimeout(
        () => controller.abort(),
        12000
      );

    try {
      const url =
        `${MAKE_WEBHOOK}` +
        `?esim_id=${encodeURIComponent(
          esimId
        )}` +
        `&sku=${encodeURIComponent(
          variant.sku
        )}` +
        `&package_code=${encodeURIComponent(
          packageCode
        )}`;

      const res = await fetch(url, {
        method: 'GET',
        cache: 'no-store',
        signal: controller.signal,
      });

      if (!res.ok) {
        throw new Error(
          `HTTP ${res.status}`
        );
      }

      const result =
        await res.json();

      if (
        currentVerificationKey() !==
        verificationKey
      ) {
        invalidateVerification();

        setMessage(
          '<strong>Your Top-Up selection changed. Please verify again.</strong>',
          'blocked'
        );

        return;
      }

      if (
        result.verified === true &&
        result.topup_behaviour ===
          'accumulates'
      ) {
        verificationState = {
          key: verificationKey,
          behaviour: 'accumulates',
          packageCode,
          verifiedAt:
            new Date().toISOString(),
          replaceAcknowledged: false,
        };

        writeVerificationProperties(
          esimId,
          variant
        );

        setMessage(
          `
            <strong>
              ✓ Adds data to your existing eSIM.
            </strong><br>

            Your remaining data will be preserved and this Top-Up will be added to it.

            <br><br>

            <small>
              Plan validity and expiration are determined by the network.
              Do not assume this Top-Up will extend or reset your eSIM's expiration date.
            </small>
          `,
          'accumulates'
        );

        enablePurchase();

        return;
      }

      if (
        result.verified === true &&
        result.topup_behaviour ===
          'replaces'
      ) {
        verificationState = {
          key: verificationKey,
          behaviour: 'replaces',
          packageCode,
          verifiedAt:
            new Date().toISOString(),
          replaceAcknowledged: false,
        };

        writeVerificationProperties(
          esimId,
          variant
        );

        setMessage(
          `
            <strong>
              ⚠ Warning — This Top-Up replaces your existing data.
            </strong><br>

            Any remaining data on your current plan will be lost.

            <br><br>

            <small>
              Plan validity and expiration are determined by the network.
              Do not assume this Top-Up will extend or reset your eSIM's expiration date.
            </small>
          `,
          'replaces'
        );

        const acknowledgement =
          document.querySelector(
            '#nhip-topup-replace-ack-wrap'
          );

        if (acknowledgement) {
          acknowledgement.style.display =
            'block';
        }

        disablePurchase();

        return;
      }

      invalidateVerification();

      if (
        result.reason ===
        'package_not_compatible'
      ) {
        setMessage(
          `
            <strong>
              This Top-Up is not compatible with the selected eSIM.
            </strong><br>

            Please choose a compatible Top-Up package.
          `,
          'blocked'
        );
      } else if (
        result.reason ===
        'esim_not_eligible'
      ) {
        setMessage(
          `
            <strong>
              This eSIM is not eligible for Top-Up.
            </strong><br>

            The plan may be expired or otherwise unavailable for Top-Up.
          `,
          'blocked'
        );
      } else {
        setMessage(
          `
            <strong>
              We could not safely verify this Top-Up.
            </strong><br>

            Purchase has been blocked.
            Please try again or contact NHIP support.
          `,
          'blocked'
        );
      }
    } catch (err) {
      console.error(
        'NHIP Top-Up verification failed',
        err
      );

      invalidateVerification();

      setMessage(
        `
          <strong>
            We could not safely verify this Top-Up.
          </strong><br>

          Purchase has been blocked.
          Please try again or contact NHIP support.
        `,
        'blocked'
      );
    } finally {
      clearTimeout(timeout);

      if (verifyButton) {
        verifyButton.disabled = false;

        verifyButton.textContent =
          'Verify Top-Up';
      }
    }
  }

  function bindPurchaseGuard() {
    const form =
      getProductForm();

    if (
      !form ||
      form.dataset
        .nhipTopupGuardBound ===
        'true'
    ) {
      return;
    }

    form.dataset.nhipTopupGuardBound =
      'true';

    form.addEventListener(
      'submit',
      (event) => {
        if (
          !purchaseIsAuthorized()
        ) {
          event.preventDefault();
          event.stopImmediatePropagation();

          disablePurchase();

          setMessage(
            '<strong>Please verify this Top-Up before continuing.</strong>',
            'blocked'
          );

          return;
        }

        const esimId =
          document
            .querySelector(
              '#nhip-existing-esim-id'
            )
            ?.value.trim();

        const variant =
          getSelectedVariant();

        if (
          !esimId ||
          !variant
        ) {
          event.preventDefault();
          event.stopImmediatePropagation();

          invalidateVerification();

          setMessage(
            '<strong>We could not safely verify this Top-Up. Please verify again.</strong>',
            'blocked'
          );

          return;
        }

        writeVerificationProperties(
          esimId,
          variant
        );
      }
    );
  }

  function buildUI() {
    const form =
      getProductForm();

    if (
      !form ||
      document.querySelector(
        '#nhip-topup-verification'
      )
    ) {
      return;
    }

    const wrapper =
      document.createElement('div');

    wrapper.id =
      'nhip-topup-verification';

    wrapper.innerHTML = `
      <div style="margin:18px 0;">

        <label
          for="nhip-existing-esim-id"
          style="
            display:block;
            font-weight:600;
            margin-bottom:6px;
          "
        >
          Existing NHIP eSIM ID
        </label>

        <input
          id="nhip-existing-esim-id"
          type="text"
          inputmode="numeric"
          pattern="[0-9]*"
          autocomplete="off"
          placeholder="Enter your NHIP eSIM ID"
          style="
            width:100%;
            padding:12px;
            border:1px solid rgba(0,0,0,.3);
            border-radius:6px;
          "
        >

        <button
          type="button"
          id="nhip-topup-find-compatible"
          class="button button--secondary"
          style="
            margin-top:10px;
            width:100%;
          "
        >
          Find Compatible Top-Ups
        </button>

        <div
          id="nhip-topup-compatible-wrap"
          style="
            display:none;
            margin-top:14px;
          "
        >

          <div
            id="nhip-topup-compatible-status"
            style="margin-bottom:8px;"
          ></div>

          <div
            id="nhip-topup-compatible-list"
          ></div>

        </div>

        <button
          type="button"
          id="nhip-topup-verify"
          class="button"
          style="
            margin-top:12px;
            width:100%;
          "
        >
          Verify Top-Up
        </button>

        <div
          id="nhip-topup-result"
          style="display:none;"
        ></div>

        <div
          id="nhip-topup-replace-ack-wrap"
          style="
            display:none;
            margin-top:14px;
          "
        >
          <label>

            <input
              type="checkbox"
              id="nhip-topup-replace-ack"
            >

            <strong>
              I understand that my remaining data will be replaced and lost.
            </strong>

          </label>
        </div>

      </div>
    `;

    const picker =
      getVariantPicker();

    if (
      picker?.parentNode
    ) {
      picker.parentNode.insertBefore(
        wrapper,
        picker
      );
    } else {
      form.parentNode.insertBefore(
        wrapper,
        form
      );
    }

    hideOriginalVariantPicker();
    hideAcceleratedCheckout();
    disablePurchase();
    clearVerificationProperties();

    setMessage(
      `
        <strong>
          Enter your NHIP eSIM ID, find compatible Top-Ups,
          select one, then verify it before purchase.
        </strong>
      `
    );

    document
      .querySelector(
        '#nhip-topup-find-compatible'
      )
      ?.addEventListener(
        'click',
        findCompatibleTopUps
      );

    document
      .querySelector(
        '#nhip-topup-verify'
      )
      ?.addEventListener(
        'click',
        verifyTopUp
      );

    document
      .querySelector(
        '#nhip-existing-esim-id'
      )
      ?.addEventListener(
        'input',
        () => {
          invalidateVerification();

          clearCompatibleTopUps();

          setMessage(
            '<strong>eSIM ID changed. Find compatible Top-Ups again before purchase.</strong>'
          );
        }
      );

    document
      .querySelector(
        '#nhip-topup-replace-ack'
      )
      ?.addEventListener(
        'change',
        (event) => {
          if (
            event.target.checked &&
            verificationState.behaviour ===
              'replaces' &&
            currentVerificationKey() ===
              verificationState.key
          ) {
            verificationState
              .replaceAcknowledged =
              true;

            const esimId =
              document
                .querySelector(
                  '#nhip-existing-esim-id'
                )
                ?.value.trim();

            const variant =
              getSelectedVariant();

            if (
              esimId &&
              variant
            ) {
              writeVerificationProperties(
                esimId,
                variant
              );
            }

            enablePurchase();
          } else {
            verificationState
              .replaceAcknowledged =
              false;

            setProperty(
              '_NHIP Replace Acknowledged',
              'false'
            );

            disablePurchase();
          }
        }
      );

    document.addEventListener(
      'change',
      (event) => {
        const target =
          event.target;

        if (
          target.matches(
            'select[name^="options"]'
          ) ||
          target.matches(
            'input[name^="options"]'
          ) ||
          target.closest(
            'variant-selects'
          ) ||
          target.closest(
            'variant-radios'
          )
        ) {
          setTimeout(() => {
            invalidateVerification();

            const selected =
              getSelectedVariant();

            if (
              !selected ||
              compatibilityState
                .selectedSku !==
                String(
                  selected.sku || ''
                )
            ) {
              compatibilityState
                .selectedSku = '';
              compatibilityState
                .selectedPackageCode = '';
            }

            setMessage(
              compatibilityState
                .selectedSku
                ? '<strong>Top-Up selection updated. Click Verify Top-Up to continue.</strong>'
                : '<strong>Top-Up selection changed. Please choose a compatible Top-Up from the list again.</strong>'
            );
          }, 150);
        }
      }
    );

    bindPurchaseGuard();
  }

  async function init() {
    hideAcceleratedCheckout();

    hideOriginalVariantPicker();

    await loadVariants();

    buildUI();

    const observer =
      new MutationObserver(() => {
        hideAcceleratedCheckout();

        hideOriginalVariantPicker();

        bindPurchaseGuard();
      });

    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true,
      }
    );
  }

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      init
    );
  } else {
    init();
  }
})();